var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = { class: "prod-offer-old__wrap" };
var _hoisted_2 = { class: "prod-offer-old__main" };
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
    key: 0,
    class: "offer-teaser__cover"
};
var _hoisted_5 = {
    key: 1,
    class: "offer-teaser__cover offer-teaser__cover--blank"
};
var _hoisted_6 = { class: "offer-teaser__name" };
var _hoisted_7 = { class: "offer-teaser__cart" };
var _hoisted_8 = { class: "offer-teaser__prices" };
var _hoisted_9 = {
    key: 0,
    class: "offer-teaser__prices-changes"
};
var _hoisted_10 = { class: "offer-teaser__price-discount" };
var _hoisted_11 = { class: "offer-teaser__price-old" };
var _hoisted_12 = { class: "offer-teaser__price-new" };
var _hoisted_13 = { class: "offer-teaser__btn" };
var _hoisted_14 = ["onClick"];
var _hoisted_15 = { class: "btn__icon" };
var _hoisted_16 = {
    key: 0,
    class: "prod-offer-old__bottom"
};
var _hoisted_17 = { class: "prod-offer-old__parts" };
var _hoisted_18 = {
    type: "button",
    class: "btn btn--2 btn--m btn--black win",
    "data-act": "bnpl_info"
};
var _hoisted_19 = { class: "btn__icon" };
import { computed, inject, ref, useTemplateRef, watch } from "vue";
import { handleAddToCartButtonClick } from "../../../../components/product/add_to_cart";
import Sprite from "../../../../components/Sprite.vue";
import Picture from "../../../../components/Picture.vue";
import OfferTypeTabs from "./OfferTypeTabs.vue";
import Price from "../../../../components/Price.vue";
import Icon from "../../../../components/Icon.vue";
import PreOrder from "../../components/PreOrder.vue";
import HintTooltip from "../../components/HintTooltip.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LegacyOfferList',
    props: {
        product: { type: Object, required: true },
        types: { type: Array, required: true },
    },
    setup: function (__props) {
        var props = __props;
        function inCart(offerId) {
            return cartOffers.value.includes(offerId);
        }
        var wrapper = ref();
        var activeType = inject('type');
        var activeOffer = inject('offer');
        var interacted = inject('interacted');
        var offers = computed(function () {
            var offers;
            if (!activeType.value) {
                offers = props.product.offers.sort(function (a, b) {
                    return props.types.findIndex(function (t) { return a.type === t.id; }) - props.types.findIndex(function (t) { return b.type === t.id; });
                });
            }
            else {
                offers = props.product.offers.filter(function (offer) { var _a; return offer.type === ((_a = activeType.value) === null || _a === void 0 ? void 0 : _a.id); });
            }
            offers = offers.map(function (o) { return (__assign(__assign({}, o), { name: o.name.replace(/\s*(тестер|refill|сэмпл)/ig, '') })); });
            if (!activeOffer.value) {
                return offers;
            }
            if (!offers.find(function (o) { return o.id === activeOffer.value.id; })) {
                activeOffer.value = null;
                return offers;
            }
            return offers;
        });
        var cartOffers = inject('cart');
        var listElement = useTemplateRef('listElement');
        if (!interacted.value) {
            activeType.value = null;
        }
        watch(activeType, function () { return setTimeout(function () { return listElement.value && listElement.value.scrollTo({ top: 0, behavior: "instant" }); }); });
        function onclick(offer) {
            interacted.value = true;
            activeOffer.value = offer;
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: "prod-offer-old",
                ref_key: "wrapper",
                ref: wrapper
            }, [
                _createVNode(OfferTypeTabs, {
                    "base-url": __props.product.url,
                    types: __props.types,
                    modelValue: _unref(activeType),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(activeType) ? (activeType).value = $event : null); })
                }, null, 8 /* PROPS */, ["base-url", "types", "modelValue"]),
                _cache[13] || (_cache[13] = _createTextVNode()),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("ul", {
                            class: "prod-offer-old__list",
                            ref_key: "listElement",
                            ref: listElement
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(offers.value, function (offer) {
                                var _a;
                                return (_openBlock(), _createElementBlock("li", {
                                    class: "prod-offer-old__item",
                                    key: offer.id
                                }, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["offer-teaser", { 'offer-teaser--highlighted': _unref(interacted) && offer.id === ((_a = _unref(activeOffer)) === null || _a === void 0 ? void 0 : _a.id) }]),
                                        onClick: function ($event) { return (onclick(offer)); }
                                    }, [
                                        (offer.image)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _createVNode(Picture, {
                                                    picture: offer.image.tiny,
                                                    fill: "",
                                                    lazy: false
                                                }, null, 8 /* PROPS */, ["picture"])
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                _createVNode(Sprite, {
                                                    name: "bottle",
                                                    size: 32
                                                })
                                            ])),
                                        _cache[7] || (_cache[7] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_6, [
                                            _createTextVNode(_toDisplayString(offer.name) + " ", 1 /* TEXT */),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(offer.distinction.filter(function (d) { return !['тестер', 'сэмпл', 'refill'].includes(d); }), function (distinction) {
                                                return (_openBlock(), _createElementBlock("span", null, _toDisplayString(distinction), 1 /* TEXT */));
                                            }), 256 /* UNKEYED_FRAGMENT */)),
                                            _cache[1] || (_cache[1] = _createTextVNode()),
                                            (offer.tester)
                                                ? (_openBlock(), _createBlock(HintTooltip, {
                                                    key: 0,
                                                    message: "тестер",
                                                    "button-class": "offer-teaser__description",
                                                    inline: "",
                                                    tester: offer.tester,
                                                    teleport: wrapper.value
                                                }, null, 8 /* PROPS */, ["tester", "teleport"]))
                                                : _createCommentVNode("v-if", true),
                                            _cache[2] || (_cache[2] = _createTextVNode()),
                                            (offer.refill)
                                                ? (_openBlock(), _createBlock(HintTooltip, {
                                                    key: 1,
                                                    message: "refill",
                                                    "button-class": "offer-teaser__description",
                                                    inline: "",
                                                    refill: offer.refill,
                                                    teleport: wrapper.value
                                                }, null, 8 /* PROPS */, ["refill", "teleport"]))
                                                : _createCommentVNode("v-if", true),
                                            _cache[3] || (_cache[3] = _createTextVNode()),
                                            (offer.sample)
                                                ? (_openBlock(), _createBlock(HintTooltip, {
                                                    key: 2,
                                                    message: "сэмпл",
                                                    "button-class": "offer-teaser__description",
                                                    inline: "",
                                                    sample: offer.sample,
                                                    teleport: wrapper.value
                                                }, null, 8 /* PROPS */, ["sample", "teleport"]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _cache[8] || (_cache[8] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, [
                                                (offer.basePrice)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                        _createElementVNode("div", _hoisted_10, "-" + _toDisplayString(offer.discountPercent) + "%", 1 /* TEXT */),
                                                        _cache[4] || (_cache[4] = _createTextVNode()),
                                                        _createElementVNode("div", _hoisted_11, [
                                                            _createVNode(Price, {
                                                                amount: offer.basePrice
                                                            }, null, 8 /* PROPS */, ["amount"])
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("v-if", true),
                                                _cache[5] || (_cache[5] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_12, [
                                                    _createVNode(Price, {
                                                        amount: offer.price
                                                    }, null, 8 /* PROPS */, ["amount"])
                                                ])
                                            ]),
                                            _cache[6] || (_cache[6] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn--2 btn--m btn--black btn--icon",
                                                    onClick: function ($event) { return (_unref(handleAddToCartButtonClick)({ id: offer.id })); },
                                                    title: "Добавить в корзину"
                                                }, [
                                                    _createElementVNode("span", _hoisted_15, [
                                                        _createVNode(Icon, {
                                                            name: inCart(offer.id) ? 'add' : 'cart'
                                                        }, null, 8 /* PROPS */, ["name"])
                                                    ])
                                                ], 8 /* PROPS */, _hoisted_14)
                                            ])
                                        ])
                                    ], 10 /* CLASS, PROPS */, _hoisted_3)
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */),
                        _cache[9] || (_cache[9] = _createTextVNode()),
                        (_unref(activeType) && _unref(activeType).disabled)
                            ? (_openBlock(), _createBlock(PreOrder, {
                                key: 0,
                                "product-id": __props.product.id,
                                type: _unref(activeType)
                            }, null, 8 /* PROPS */, ["product-id", "type"]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    (offers.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("button", _hoisted_18, [
                                    _createElementVNode("span", _hoisted_19, [
                                        _createVNode(Icon, {
                                            name: "parts",
                                            size: 20
                                        })
                                    ]),
                                    _cache[10] || (_cache[10] = _createTextVNode()),
                                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "btn__label" }, "Оплата частями", -1 /* CACHED */))
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ], 512 /* NEED_PATCH */));
        };
    }
});
